import type { AppRouteRecordRaw } from "@/types/router";
import { LAYOUT } from "@/router/constants";

const alliance: AppRouteRecordRaw = {
  path: "/alliance",
  name: "Alliance",
  redirect: "/alliance/report",
  component: LAYOUT,
  meta: {
    title: "联盟",
  },
  children: [
    {
      path: "trend",
      name: "AllianceTrend",
      component: () => import("@/views/alliance/trend/index.vue"),
      meta: {
        title: "价格行情",
      },
    },

    {
      path: "trend",
      name: "AllianceTrend",
      component: () => import("@/views/alliance/trend/index.vue"),
      meta: {
        title: "价格行情",
      },
    },

    {
      path: "contribution",
      name: "AllianceContribution",
      component: () => import("@/views/alliance/contribution/index.vue"),
      meta: {
        title: "贡献榜单",
      },
    },
    {
      path: "member",
      name: "AllianceMember",
      component: () => import("@/views/alliance/member/index.vue"),
      meta: {
        title: "联盟成员",
      },
    },
  ],
};

export default alliance;
